/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as ActorDefs from "../../app/bsky/actor/defs.defs.js";
import * as GraphBlock from "../../app/bsky/graph/block.defs.js";

const $nsid = "place.stream.defs";

export { $nsid };

type BlockView = { $type?: "place.stream.defs#blockView";"uri":l.AtUriString;"cid":l.CidString;"blocker":ActorDefs.ProfileViewBasic;"record":GraphBlock.Main;"indexedAt":l.DatetimeString };

export type { BlockView };

const blockView = /*#__PURE__*/ l.typedObject<BlockView>($nsid, "blockView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"}),"blocker":/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any),"record":/*#__PURE__*/ l.ref<GraphBlock.Main>((() => GraphBlock.main) as any),"indexedAt":/*#__PURE__*/ l.string({"format":"datetime"})}));

export { blockView };

type Renditions = { $type?: "place.stream.defs#renditions";"renditions":(Rendition)[] };

export type { Renditions };

const renditions = /*#__PURE__*/ l.typedObject<Renditions>($nsid, "renditions", /*#__PURE__*/ l.object({"renditions":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Rendition>((() => rendition) as any), )}));

export { renditions };

type Rendition = { $type?: "place.stream.defs#rendition";"name":string };

export type { Rendition };

const rendition = /*#__PURE__*/ l.typedObject<Rendition>($nsid, "rendition", /*#__PURE__*/ l.object({"name":/*#__PURE__*/ l.string()}));

export { rendition };

/** A game from the gamesgamesgamesgames catalog, identified by its AT URI. */
type ActivityGame = { $type?: "place.stream.defs#activityGame";"uri":l.AtUriString;

  /**
   * Cached display name of the game.
   */
  "name"?:string };

export type { ActivityGame };

/** A game from the gamesgamesgamesgames catalog, identified by its AT URI. */
const activityGame = /*#__PURE__*/ l.typedObject<ActivityGame>($nsid, "activityGame", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"name":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())}));

export { activityGame };

/** A non-game activity with a well-known label. */
type ActivityLabel = { $type?: "place.stream.defs#activityLabel";"label":"events" | "just_chatting" | "podcasting" | "music" | "art" | "software_dev" | "cooking" | "miniatures" | "makers_crafting" | "fitness" | "sports" | l.UnknownString };

export type { ActivityLabel };

/** A non-game activity with a well-known label. */
const activityLabel = /*#__PURE__*/ l.typedObject<ActivityLabel>($nsid, "activityLabel", /*#__PURE__*/ l.object({"label":/*#__PURE__*/ l.string<{"knownValues":["events","just_chatting","podcasting","music","art","software_dev","cooking","miniatures","makers_crafting","fitness","sports"]}>()}));

export { activityLabel };
